export const isReportMessageUnread = (report) => report.numberOfUnseenMessages > 0 || !report.isSeen;
